import { has } from 'lodash'

export interface GenerateHmacSignatureOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SignedUrlRedirect: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGenerateHmacSignatureOutput = (obj: any): obj is GenerateHmacSignatureOutput => {
  const SignedUrlRedirect = 'SignedUrlRedirect'

  return has(obj, SignedUrlRedirect)
}
